module.exports = __webpack_public_path__ + "static/media/core5.035e948a.jpeg";